/**
 * istanbul ignore file
 *
 * @format
 */

import { Checkout, Donations } from '@cart-checkout/data-access/interfaces';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

// to be utilized when API interaction set up
// import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { DCSG_CONSTANTS } from '@shared/data-access/constants';
// import { MediaType } from '@shared/data-access/enums';

@Injectable({
  providedIn: 'root',
})
export class DonationsDao {
  private readonly http = inject(HttpClient);

  postDonationsUpdate(donations: Donations): Observable<any> {
    return this.http.post<Checkout>(
      'api/v1/checkouts/6cd0355f-ed9d-42a0-aa08-0a8b49820507/v1/donation', // this has a hardcoded identifier in it, but will be replaced with the api integration
      donations,
      // this.DEFAULT_HTTP_HEADERS // will define when API interaction set up
    );
  }

  deleteDonations(): Observable<any> {
    return this.http.delete<Checkout>(
      'api/v1/checkouts/95f368e1-4dfd-4124-bac4-7c885d25a6b4/v1/donation',
    );
  }
}
